import React from "react";
import PropTypes from "prop-types";

const ArticleSearch = ({ title, subtitle }) => {
  return (
    <div className="mb-2 rounded-lg p-4">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
        <div>
          <h4 className="text-xl font-bold text-navy-700 dark:text-white">
            {title}
          </h4>
          <p className="mt-1 text-sm text-gray-600">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};
ArticleSearch.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default ArticleSearch;
